module.exports = __webpack_public_path__ + "static/media/primaLogoPdf.495d787f.svg";